import { render, staticRenderFns } from "./DatabaseConnection.html?vue&type=template&id=07550199&"
import script from "./DatabaseConnection.vue?vue&type=script&lang=js&"
export * from "./DatabaseConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports